<template>
  <section class="px-16 sm-max:mt-4 sm-max:px-5 testimonials" >
    <div class="relative px-10 sm-max:px-6">

      <ClientOnly>
        <Swiper
            :class="'relative overflow-hidden mt-12 md-max:mt-10'"
            :autoplay="{ delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true, }"

            :modules="[SwiperNavigation,SwiperAutoplay]"
            :slidesPerView="1"
            :spaceBetween="50"
            :loop="true"
            :navigation = "{
              nextEl: '.swiper-button-next-1',
    prevEl: '.swiper-button-prev-1'
            }"
            :breakpoints="{
              768: { slidesPerView: 2, },
            }">
          <SwiperSlide v-for="slide in slides" :key="slide.name">
            <div class="text-center">
              <nuxt-img
                  class="w-full m-auto"
                  loading="lazy"
                  format="webp"
                  width="460"
                  height="259"
                  :alt="slide.imgAlt"
                  sizes="sm:440px  md:100vw lg:100vw xl:460px"
                  :src="slide.imgSrc"
              />
              <div class="pt-8 text-3xl text-ratingYellow">{{ slide.rating }}</div>
              <div class="pt-2 mb-4 text-base leading-4 sm-max:text-15 md-max:px-4 sm-max:leading-5 md:leading-27" v-html=" slide.testimonial "></div>
              <h3 class="text-xl leading-6 sm-max:text-15 font-roboto" v-html="slide.name"></h3>
              <h4 class="text-base leading-4 sm-max:text-xs">{{ slide.title }}</h4>
            </div>
          </SwiperSlide>

        </Swiper>

        <div class="absolute cursor-pointer swiper-button-prev-1 -translate-x-2/4 -translate-y-2/4 top-2/4 md:-left-3 -left-0"></div>
        <div class="absolute cursor-pointer swiper-button-next-1 -translate-x-2/4 -translate-y-2/4 top-2/4 md:-right-3 -right-5"></div>

      </ClientOnly>
    </div>
  </section>
</template>

<script setup>


const props = defineProps({
  slides: {
    type: Array,
    default: () => [
      {
        imgSrc: "/assets/images/aron-profile-img.jpg",
        imgAlt: "Shaun Hadsall",
        rating: "★★★★★",
        testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
        name: "Dr Aaron Oxenrider",
        title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
      },
      {
        imgSrc: "/assets/images/gary-profile-img.jpg",
        imgAlt: "Dr Gary Sanchez",
        rating: "★★★★★",
        testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
        name: "Dr Gary Sanchez",
        title: "Board Certified Dentist",
      },
      {
        imgSrc: "/assets/images/joseph-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
        name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
        title: "Natural Bio Health Hormones & Weight Loss.",
      },
      {
        imgSrc: "/assets/images/shaun-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
        name: "Shaun Hadsall",
        title: "Owner of GetLeanAfter40",
      },
      {
        imgSrc: "/assets/images/john-profile-img.jpg",
        imgAlt: "Dr Aaron Oxenrider",
        rating: "★★★★★",
        testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
        name: "John Rowley",
        title: "America's Lifestyle Strategist, Best Selling Author and Speaker",
      },
    ],
  },
});


defineBuilderComponent({
    friendlyName: "Testimonials",
    canHaveChildren: true,
    inputs: [
        {
            name: "slides",
            type: "list",
            subFields: [
                {
                    name: "imgSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "svg"
                    ],
                    defaultValue: ""
                },
                {
                    name: "imgAlt",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "rating",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "testimonial",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "name",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "title",
                    type: "string",
                    defaultValue: ""
                }
            ],
            defaultValue: [
                {
                    imgSrc: "/assets/images/aron-profile-img.jpg",
                    imgAlt: "Shaun Hadsall",
                    rating: "★★★★★",
                    testimonial: "“Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
                    name: "Dr Aaron Oxenrider",
                    title: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
                },
                {
                    imgSrc: "/assets/images/gary-profile-img.jpg",
                    imgAlt: "Dr Gary Sanchez",
                    rating: "★★★★★",
                    testimonial: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
                    name: "Dr Gary Sanchez",
                    title: "Board Certified Dentist"
                },
                {
                    imgSrc: "/assets/images/joseph-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "“Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat I look forward to every day.”",
                    name: "Joseph R. Feste, M.D., FACOG, AACS, AACG",
                    title: "Natural Bio Health Hormones & Weight Loss."
                },
                {
                    imgSrc: "/assets/images/shaun-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "\"Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. I look forward to my daily cup (or two) each day to help boost my immune health and increase my productivity.\"",
                    name: "Shaun Hadsall",
                    title: "Owner of GetLeanAfter40"
                },
                {
                    imgSrc: "/assets/images/john-profile-img.jpg",
                    imgAlt: "Dr Aaron Oxenrider",
                    rating: "★★★★★",
                    testimonial: "\"Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr Charles!\"",
                    name: "John Rowley",
                    title: "America's Lifestyle Strategist, Best Selling Author and Speaker"
                }
            ]
        }
    ]
});
</script>

<style>
.testimonials .swiper-wrapper {
  width: 100%;
  height: 100%;
}
.testimonials .swiper-button-next{
  @apply !text-productTitle sm-max:pl-2 pt-8

}

.testimonials .swiper-button-prev {
  @apply !text-productTitle sm-max:pr-2 pt-8
}
.swiper-button-next:after,.swiper-button-prev:after {

}

.testimonials .swiper-button-next-1:after,.testimonials .swiper-button-prev-1:after {
  content: url('/assets/images/arrowLeft.svg');
  /* Optional: Adjust the size, position, etc. as needed */
  width: 24px;
  height: 30px;
  color: #956449 !important;;
  display: inline-block;

}

.testimonials .swiper-button-next-1:after {
  transform: rotate(180deg);
  position: relative;
  bottom: 5px;
}

</style>